import { tokens } from "gatsby-env-variables"

import {
  getIsCookieAcceptedFromStorage,
  saveCurrentPosition
} from "@garantidos/utils"
import appTrackers from "@garantidos/utils/tracking/appTrackers"

import configure from "@mobi/ds/configure"
import analytics from "@mobi/libraries/analytics"

import "styles/index.scss"

export const wrapRootElement = ({ element }) => element

configure({
  originFonts: "extern",
  fonts: {
    ItauDisplay: [900],
    ItauText: [400, 700]
  },
  setStyleVariablesInHTML: false
})

if (getIsCookieAcceptedFromStorage()) {
  saveCurrentPosition()
}

Promise.resolve(import("@garantidos/utils/bootstrap"))

if (!window.analyticsData) {
  window.analyticsData = {}
}

analytics.setup({
  segmentId: tokens.SEGMENT,
  GTMId: tokens.GTMId,
  trackings: appTrackers,
  isSDKTrackings: true
})
